import React, { useState, useEffect } from 'react';
import Modal, { ModalProvider } from '../../partials/Modal/Modal';
import ProgressBar from '../../partials/ProgressBar/index';
import VideoWrapper from './partials/VideoWrapper/VideoWrapper';
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Button from '../../partials/Button';
import Scroll from "../../partials/Scroll/Scroll";
import './ModesOfOperation.scss';

const ModesOfOperation = (props) => {

  const { data, complet } = props;
  const [ modalVisibility, setModalVisibility ] = useState(false);
  const [ modalData, setModalData ] = useState({
    header: 'Header here',
    body: 'content of the modal',
    button: 'Next',
    onClose: () => { } 
  });
  const [ videoVisible, setVideoVisible ] = useState(true);
  const [ categories, setCategories ] = useState([]);
  const [ closebuttonstate, setClosebuttonstate ] = useState(false);
  const [ Nextbuttonstate, setnextbuttonstate ] = useState(0);
  const numberofvideos = data.videos.length;
  const [completed, setCompleteViews] = useState(false);
  // You can add an additional event if you need after the video ends
  const handleEnded = (video) => {
    if(video.hasQuestions) {
      //setVideoVisible(false);
      setClosebuttonstate(true);
    }
    if(!video.hasQuestions){
      setModalVisibility(true);
      video.completionStatus = true;
      setnextbuttonstate(Nextbuttonstate+1);
    }
  }
  const handleAnswered = (video) =>{
    video.completionStatus = true;
    setnextbuttonstate(Nextbuttonstate+1);
    clearModal();
  }
  const showModal = video => {
    setModalData({
      header: video.title,
      body: <VideoWrapper {...video} visible={true} setClosebuttonstate={setClosebuttonstate} onEnded={ () => { handleEnded(video) } } onAnswered={()=>{handleAnswered(video)}}/>,
      button: 'Close',
      closebuttonstate: closebuttonstate,
      onClose: () => { clearModal() },
      size: 'lg'
    });
    setVideoVisible(true);
    setModalVisibility(true);

  };

  const clearModal = () => {
    setModalVisibility(false);
    setModalData({});
    setClosebuttonstate(false);
  }

  // This function returns a list of videos separated by category
  const getVideoCategories = () => {
    let cats = [];
    data.videos.forEach( (video) => {
      if(!cats.includes(video.category)) {
        cats.push(video.category);
      }
    });
    setCategories(cats);
  }

  useEffect(() => {
    if(data.subtype==='videolist') {
      getVideoCategories();
    }
  }, [])

  useEffect(() => {
    console.log(Nextbuttonstate, '===', numberofvideos);
    if(Nextbuttonstate === numberofvideos) {
      console.log("Completed")
      setCompleteViews(true)
    }
  }, [Nextbuttonstate])

  return (
    <ModalProvider>
      <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}> 
        <div className="back-btn-container">
          <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
        </div>
        <div className="grouped-videos-holder">
          <div className="modes-of-operation">
            <Scroll className="textScroll">
              <div className="left-panel">        
                <div className="contentDiv" dangerouslySetInnerHTML={{ __html: data.body }}></div>
              </div>
            </Scroll>
            <Scroll className="videoScroll">
              <div className="right-panel">
                {/* Layout for multiple videos */}
                { data.subtype === 'videolist' &&
                  <>
                    { categories.map( (category, categoryIndex) => (
                      <div className="category-list" key={`category-list-${categoryIndex}`}>
                        <h3>{category}</h3>
                        <div className="video-list">
                          { data.videos.map( (video, videoIndex) => {
                            if(category===video.category) {
                              return (
                                <div className="video-item" key={`video-item-${videoIndex}`} onClick={ () => { showModal(video) }}>
                                  <img src={video.thumbnail} alt={category} />
                                  <div className="label" dangerouslySetInnerHTML={{ __html: video.title }}></div>
                                  <div className="play-indicator"></div>
                                  {video.completionStatus==true&&<div className="completion-indicator"></div>}
                                </div>
                              );
                            }
                          } ) }   
                        </div>
                      </div>
                    )) }
                  </>
                }
                {/* Layout for a single video */}
                { data.subtype === 'singlevideo' &&
                  <div className="single-video">
                      <div className="video-item">
                        <img src={data.video.thumbnail} alt={data.video.title} />
                        <div className="play-indicator" onClick={ () => { showModal(data.video) } }></div>
                        {data.video.completionStatus==true&&<div className="completion-indicator"></div>}
                      </div>
                  </div>
                }
              </div>
            </Scroll>
          </div>
          </div>
        {completed &&
        <button  
          onClick={() => {
            if (props.onComplete) {
                props.onComplete()
            }
          }} 
          className={"global-button"}
          style={{bottom: '40px', right: '50px', position: 'absolute'}}>
            Next
        </button>
        }
        {modalVisibility &&
              <Modal variant='white' size={closebuttonstate ? 'xlg' : 'md'} closebuttonstate={closebuttonstate} onClickClose={modalData.onClose}>
              {modalData.body}
            </Modal>
        }  
      </InteractionContainer>   
    </ModalProvider>
  );

};

export default ModesOfOperation;